<template>
  <div class="panel-root stack tight">
    <UiSectionHeader>
      <template #title>{{ ICONS.inspectKinds.player }} Players</template>
      <template #actions>
        <UiChip variant="muted" class="stat-mono num">{{ formatNumber(players.length) }}</UiChip>
      </template>
    </UiSectionHeader>

    <UiCallout v-if="players.length === 0" variant="info">You are alone here.</UiCallout>

    <div v-else class="list panel-scroll scroll">
      <PlayerRow
        v-for="p in players"
        :key="p.id"
        :player="p"
        @inspect="emit('inspect', $event.id)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICONS } from "../../lib/icons";
import { formatNumber } from "../../lib/format";
import PlayerRow, { type PlayerRowModel } from "../world/rows/PlayerRow.vue";
import UiCallout from "../ui/UiCallout.vue";
import UiChip from "../ui/UiChip.vue";
import UiSectionHeader from "../ui/UiSectionHeader.vue";

defineProps<{
  players: PlayerRowModel[];
}>();

const emit = defineEmits<{
  inspect: [playerId: string];
}>();
</script>

<style scoped>
.panel-root {
  min-width: 0;
}

.list {
  display: grid;
  gap: 0.6rem;
}
</style>
